import type { Card } from './heads-up-poker';
export type BridgeSide = 'First' | 'Second';
export type BridgeSeat = 'north' | 'east' | 'south' | 'west';
export interface BridgeNtState {
  phase: 'awaiting_hands' | 'play' | 'complete';
  opening_leader: BridgeSeat;
  provided: [boolean, boolean];
  hands: [Card[] | null, Card[] | null, Card[] | null, Card[] | null];
  completed: {leader: BridgeSeat; cards: Card[]; winner: BridgeSeat}[];
  current: {leader: BridgeSeat; cards: Card[]};
  tricks_won: [number, number];
  outcome: {winner: BridgeSide | null; ns_tricks: number; dd_ns_tricks: number; ns_score: number} | null;
}
export type BridgeNtMove = {play: {card: Card}} | {provide_hands: {hands: [Card[], Card[]]; reveal?: {shares: string[]; proofs: string[]}}};
export const BRIDGE_SEATS: BridgeSeat[] = ['north', 'east', 'south', 'west'];
export const bridgePositions = (side: BridgeSide): number[] => {
  const start = side === 'First' ? 0 : 13;
  return Array.from({length: 13}, (_, i) => start + i).concat(Array.from({length: 13}, (_, i) => start + 26 + i));
};
export function bridgeToPlay(state: BridgeNtState): number {
  return (BRIDGE_SEATS.indexOf(state.current.leader) + state.current.cards.length) % 4;
}
export function bridgeRemaining(state: BridgeNtState, seat: number): Card[] | null {
  const hand = state.hands[seat];
  if (!hand) return null;
  const played = new Set([...state.completed.flatMap(t => t.cards), ...state.current.cards].map(c => `${c.suit}:${c.rank}`));
  return hand.filter(c => !played.has(`${c.suit}:${c.rank}`));
}

// User-selected bidding-box palette: spades blue, hearts red, diamonds orange, clubs green.
export const BRIDGE_SUIT_COLORS = ['#1d4ed8', '#b42331', '#9a4a00', '#166534'] as const;
export const bridgeSuitColor = (suit: number): string => BRIDGE_SUIT_COLORS[suit] ?? BRIDGE_SUIT_COLORS[0];
